// Sticky add to cart on desktop (snippets/product-sticky-add-to-cart.liquid): the whole card is the add to cart.
// - A click anywhere on the card clicks its button, which submits the product form.
// - Hovering the card runs the button's own hover (the theme's band, js/common/typography/button.js listens for
//   mouseenter / mouseleave on the button). The card forwards those to the button, and the button's own enter / leave
//   are held back, so moving between the card and the button does not restart the band.
// The bar re-renders on variant changes (product-rerender), so the button is looked up on each event.
// Keyboard users still tab to the button itself; the card click is only a larger target for the pointer.

const buttonOf = (sticky) => sticky.querySelector('button[type="submit"]');
const isInactive = (button) => !button || button.matches(':disabled, [aria-busy="true"]');

const setup = (sticky) => {
  if (sticky.dataset.cardClick) return;
  sticky.dataset.cardClick = 'true';

  ['mouseenter', 'mouseleave'].forEach((type) => {
    sticky.addEventListener(type, (event) => {
      if (event.isTrusted && event.target !== sticky && event.target === buttonOf(sticky)) {
        event.stopPropagation();
      }
    }, true);
  });

  sticky.addEventListener('mouseenter', () => {
    const button = buttonOf(sticky);
    if (!isInactive(button)) button.dispatchEvent(new MouseEvent('mouseenter'));
  });

  sticky.addEventListener('mouseleave', () => {
    buttonOf(sticky)?.dispatchEvent(new MouseEvent('mouseleave'));
  });

  sticky.addEventListener('click', (event) => {
    const button = buttonOf(sticky);
    if (isInactive(button) || event.target.closest('button, a, input, select, label')) return;
    button.click();
  });
};

const run = () => document.querySelectorAll('product-sticky-add-to-cart').forEach(setup);

run();
document.addEventListener('shopify:section:load', run);
